"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBedrooms = exports.reducer = exports.bedsToEditState = void 0;
const React = __importStar(require("react"));
const UnsupportedValueError_1 = __importDefault(require("../../../../util/UnsupportedValueError"));
const bedsToEditState = (beds) => {
    const sortedBeds = beds.sort((a, b) => a.id - b.id);
    const state = {
        'initialised': beds.length !== 0,
        'rooms': sortedBeds.reduce((bedsState, bed) => {
            if (bed.bedroom === null) {
                return bedsState;
            }
            const bedroom = bed.bedroom;
            if (bedroom in bedsState) {
                bedsState[bedroom].beds.push(bed);
            }
            else {
                bedsState[bedroom] = { id: bedroom, beds: [bed] };
            }
            return bedsState;
        }, {}),
        'extraBeds': beds.filter((bed) => bed.bedroom === null),
    };
    return state;
};
exports.bedsToEditState = bedsToEditState;
const defaultBed = (bedroomId) => ({
    bed_type: 'double',
    bedroom: bedroomId,
    is_extra: false,
});
const defaultExtraBed = () => ({
    bed_type: 'double',
    bedroom: null,
    is_extra: true,
});
const defaultBedroom = (id) => ({
    id,
    beds: [defaultBed(id)],
});
const reducer = (state, action) => {
    switch (action.type) {
        case 'reset':
            return action.state;
        case 'newBedroom': {
            const rooms = Object.keys(state.rooms);
            const ids = rooms && rooms.length ? rooms : ['0'];
            const nextId = Math.max(...ids.map((id) => parseInt(id, 10))) + 1;
            return Object.assign(Object.assign({}, state), { rooms: Object.assign(Object.assign({}, state.rooms), { [nextId]: defaultBedroom(nextId) }) });
        }
        case 'removeBedroom': {
            const removeId = Math.max(...Object.keys(state.rooms).map(Number));
            // `delete`ing the room isn't pure enough, so destructure it throwing away the room to be deleted and
            // keep the other bedrooms
            const _a = state.rooms, _b = removeId, _ = _a[_b], bedrooms = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return Object.assign(Object.assign({}, state), { rooms: bedrooms });
        }
        case 'newBed': {
            const bedroom = state.rooms[action.bedroomId];
            bedroom.beds.push(defaultBed(action.bedroomId));
            return Object.assign(Object.assign({}, state), { rooms: Object.assign(Object.assign({}, state.rooms), { [action.bedroomId]: bedroom }) });
        }
        case 'removeBed': {
            const bedroom = state.rooms[action.bedroomId];
            bedroom.beds.splice(action.bed, 1);
            return Object.assign(Object.assign({}, state), { rooms: Object.assign(Object.assign({}, state.rooms), { [action.bedroomId]: bedroom }) });
        }
        case 'newExtraBed': {
            const extraBeds = state.extraBeds;
            extraBeds.push(defaultExtraBed());
            return Object.assign(Object.assign({}, state), { extraBeds });
        }
        case 'removeExtraBed': {
            const extraBeds = state.extraBeds;
            extraBeds.splice(action.bed, 1);
            return Object.assign(Object.assign({}, state), { extraBeds });
        }
        case 'setBedType': {
            if (action.bedroomId !== null && action.bedroomId !== undefined) {
                const bedroom = state.rooms[action.bedroomId];
                bedroom.beds[action.bed].bed_type = action.bedType;
                return Object.assign(Object.assign({}, state), { rooms: Object.assign(Object.assign({}, state.rooms), { [action.bedroomId]: bedroom }) });
            }
            else {
                const extraBeds = state.extraBeds;
                extraBeds[action.bed].bed_type = action.bedType;
                return Object.assign(Object.assign({}, state), { extraBeds });
            }
        }
        default:
            throw new UnsupportedValueError_1.default(action);
    }
};
exports.reducer = reducer;
const useBedrooms = (propertyBeds, update) => {
    const [state, dispatch] = React.useReducer(exports.reducer, propertyBeds, exports.bedsToEditState);
    // useReducer will be initialised when the beds list is empty (hasn't been fetched yet). So we need to manually force
    // initialisation ourselves.
    React.useEffect(() => {
        if (propertyBeds.length !== 0 && state.initialised === false) {
            dispatch({ type: 'reset', state: (0, exports.bedsToEditState)(propertyBeds) });
        }
    }, [propertyBeds]);
    return { bedroomsEditState: state, dispatch };
};
exports.useBedrooms = useBedrooms;
//# sourceMappingURL=data.js.map